import React from "react";
import { Outlet } from "react-router-dom";
import SelectionAccess from "./SelectionAccess";
import SelectionManage from "./SelectionManage";
import SelectionPrint from "./SelectionPrint";

const SelectionPage = () => (
  <div className="layout-content px-3 sm:px-5 md:px-5">
    <Outlet />
  </div>
);

export { SelectionPage, SelectionAccess, SelectionManage, SelectionPrint };
